<div class="mainComponent createCustomGroupComponent">
    <div class="customCalulations">
        <div class="CustomClassBlock">
            <div class="customText custom-metric-percentage" (click)="CustomMetricClicked('custommetricpercentage')"
                [ngClass]="{'selected':isCustomMetricPercentage}">Custom Percentage Metric</div>
            <div class="customText custom-mean-metric" (click)="CustomMetricClicked('custommeanmetric')"
                [ngClass]="{'selected':isCustomMeanMetric}">Custom Mean Metric</div>
        </div>



        <div class="childContent" [ngClass]="{ 'preview-expand-size': isPreviewExpand }">
            <div class="RowContent" [ngClass]="{ hidden: isPreviewExpand }">
                <div class="RowMainContent">
                    <div class="rowHeader">
                        <div class="rowText">METRICS</div>
                        <!-- <div class="rowDelete" (click)="clearSelection('CustomGroup')">
       <div class="deleteIcon"></div>
     </div> -->
                    </div>
                    <div class="row-body-block">
                        <div class="rowParent">
                            <div class="rowParentContent">
                                <div class="search-reset">
                                    <div class="sub-items-search">
                                        <input class="searchinput" type="text" placeholder="Search"
                                            [(ngModel)]="searchmetric" autocomplete="off" name="searchmetric" />
                                        <div class="search-icon">
                                            <div class="search-icon-image"></div>
                                        </div>
                                    </div>
                                    <div class="reset-button" (click)="searchmetric=''">
                                        <!-- (click)="clearCustomGroupSelection();clearCustomCalculationSelection()" -->
                                        <!-- (click)="resetmetricselections(row.widgetNumber,i.subWidgetName,row.metric,row.metric.metric_select!=3 || metricGroupLength == 0 ?row.metric.metricselect1and2:row.metric.metricselect3,pageCounter,i,'')" -->
                                        <div class="resetbtn"></div>
                                    </div>
                                </div>
                                <div class="metricList">
                                    <div class="metric"
                                        *ngFor="let item of metrics|searchchartoutput:searchmetric;let i=index">
                                        <div class="metric-block" *ngIf="item.option!=''">
                                            <input [type]="'checkbox'" [id]="item.option" [class.disabled]="!item.isSelected"
                                                [checked]="item.isSelected!=null?item.isSelected:false"
                                                (click)="removeGroupObjects('',item.option,item.response_code,item.variable_code,'',item.is_multi_punch,0)"
                                                />
                                            <label class="metricLabelOption" for="item.option"
                                                (click)="generateGroupObjects('',item.option,item.response_code,item.variable_code,'',item.is_multi_punch,0)"
                                                [title]="item.option">{{item.option}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ColumnContent" [ngClass]="{ 'preview-expand-size': isPreviewExpand }">
                <div class="columnChildContent" [ngClass]="{ hidden: isPreviewExpand }">
                    <div class="ColumnHeader">
                        <div class="columnIcon"></div>
                        <div class="columnText">METRIC SUMMARY</div>
                    </div>
                    <div class="createCustomGroupBody">
                        <div class="customGroup-btn-container">
                            <div class="customGroup-btn-inner-container" *ngIf="isCustomMetricPercentage">
                                <div class="customGroup-btn config-btn" id="openParaButton" [ngClass]="
             disabledCustomGroupOperatorList.includes('openParaButton')
               ? 'disabled'
               : ''
           " (click)="bindCustomGroupOperatorClick($event, '(')">
                                    (
                                </div>
                                <div class="customGroup-btn config-btn" id="closeParaButton" [ngClass]="
             disabledCustomGroupOperatorList.includes(
               'closeParaButton'
             )
               ? 'disabled'
               : ''
           " (click)="bindCustomGroupOperatorClick($event, ')')">
                                    )
                                </div>
                                <div class="customGroup-btn config-btn" id="notButton" [ngClass]="
             disabledCustomGroupOperatorList.includes('notButton')
               ? 'disabled'
               : ''
           " (click)="bindCustomGroupOperatorClick($event, 'NOT')">
                                    NOT
                                </div>
                                <div class="customGroup-btn config-btn" id="andButton" [ngClass]="
             disabledCustomGroupOperatorList.includes('andButton')
               ? 'disabled'
               : ''
           " (click)="bindCustomGroupOperatorClick($event, 'AND')">
                                    AND
                                </div>
                                <div class="customGroup-btn config-btn" id="orButton" [ngClass]="
             disabledCustomGroupOperatorList.includes('orButton')
               ? 'disabled'
               : ''
           " (click)="bindCustomGroupOperatorClick($event, 'OR')">
                                    OR
                                </div>
                                <div class="customGroup-btn config-btn" id="addButton" [ngClass]="
             disabledCustomGroupOperatorList.includes('addButton')
               ? 'disabled'
               : ''
           " (click)="bindCustomGroupOperatorClick($event, '+')">
                                    +
                                </div>
                                <div class="customGroup-btn config-btn" id="subtractButton" [ngClass]="
             disabledCustomGroupOperatorList.includes('subtractButton')
               ? 'disabled'
               : ''
           " (click)="bindCustomGroupOperatorClick($event, '-')">
                                    -
                                </div>
                                <div class="customGroup-btn config-btn" id="multiplyButton" [ngClass]="
             disabledCustomGroupOperatorList.includes('multiplyButton')
               ? 'disabled'
               : ''
           " (click)="bindCustomGroupOperatorClick($event, '*')">
                                    *
                                </div>
                                <div class="customGroup-btn config-btn" id="divideButton" [ngClass]="
             disabledCustomGroupOperatorList.includes('divideButton')
               ? 'disabled'
               : ''
           " (click)="bindCustomGroupOperatorClick($event, '/')">
                                    /
                                </div>
                                <div class="customGroup-btn config-btn" id="numeralButton" [ngClass]="
             disabledCustomGroupOperatorList.includes('numeralButton')
               ? 'disabled'
               : ''
           " (click)="bindCustomGroupOperatorClick($event, 'NUMERAL')">
                                    NUMERAL
                                </div>
                            </div>
                            <div class="threshold-btn-container" *ngIf="isCustomMetricPercentage">
                                <button class="threshold-btn config-btn"
                                        [disabled]="!isThresholdEnabled"
                                        [ngClass]="{'threshold-enabled': isThresholdEnabled, 'threshold-disabled': !isThresholdEnabled}"
                                        [title]="isThresholdEnabled ? 'Click to set threshold' : 'Select * or / to enable threshold'"
                                        (click)="onThresholdClick()">
                                    Threshold
                                </button>
                            </div>
                            <div class="customGroup-btn-inner-container" *ngIf="isCustomMeanMetric"
                                style="width:60% !important">
                                <div class="customGroup-btn config-btn" id="openParaButton" [ngClass]="
                                    disabledCustomCalculationOperatorList.includes('openParaButton')
                                      ? 'disabled'
                                      : ''
                                  " (click)="bindCustomCalculationOperatorClick($event, '(')">
                                    (
                                </div>
                                <div class="customGroup-btn config-btn" id="closeParaButton" [ngClass]="
                                    disabledCustomCalculationOperatorList.includes(
                                      'closeParaButton'
                                    )
                                      ? 'disabled'
                                      : ''
                                  " (click)="bindCustomCalculationOperatorClick($event, ')')">
                                    )
                                </div>
                                <div class="customGroup-btn config-btn" id="addButton" [ngClass]="
                                    disabledCustomCalculationOperatorList.includes('addButton')
                                      ? 'disabled'
                                      : ''
                                  " (click)="bindCustomCalculationOperatorClick($event, '+')">
                                    +
                                </div>
                                <div class="customGroup-btn config-btn" id="subtractButton" [ngClass]="
                                    disabledCustomCalculationOperatorList.includes('subtractButton')
                                      ? 'disabled'
                                      : ''
                                  " (click)="bindCustomCalculationOperatorClick($event, '-')">
                                    -
                                </div>
                                <div class="customGroup-btn config-btn" id="multiplyButton" [ngClass]="
                                    disabledCustomCalculationOperatorList.includes('multiplyButton')
                                      ? 'disabled'
                                      : ''
                                  " (click)="bindCustomCalculationOperatorClick($event, '*')">
                                    *
                                </div>
                                <div class="customGroup-btn config-btn" id="divideButton" [ngClass]="
                                    disabledCustomCalculationOperatorList.includes('divideButton')
                                      ? 'disabled'
                                      : ''
                                  " (click)="bindCustomCalculationOperatorClick($event, '/')">
                                    /
                                </div>
                                <div class="customGroup-btn config-btn" id="numeralButton" [ngClass]="
                                    disabledCustomCalculationOperatorList.includes('numeralButton')
                                      ? 'disabled'
                                      : ''
                                  " (click)="bindCustomCalculationOperatorClick($event, 'NUMERAL')">
                                    NUMERAL
                                </div>



                            </div>
                        </div>
                        <div class="operator-note" *ngIf="isCustomMetricPercentage">
                            <span class="note-text">Note: Logical operators and Mathematical operators can't be taken together</span>
                        </div>

                        <div class="custom-peer-table-container" *ngIf="isCustomMetricPercentage">
                            <div class="custom-peer-tableElement"
                                *ngFor="let list of customGroupSelectionsObj; let ind = index">
                                <div class="custom-peer-tableElement-span"
                                    [style]="list.notFound?'border:1px solid red':''"
                                    [ngClass]="{firstOpeningTag: list.displayString == '(' && ind == 0,'active-customgroup-item': ind == customGroupItemIndex}"
                                    title="{{ list.displayString }}"
                                    (click)="selectedVariableItem(ind,list.operatorValue)">
                                    {{ list.displayString }}
                                </div>
                                <div class="closeTag" [ngClass]="{
             'active-customgroup-item': ind == customGroupItemIndex
           }" *ngIf="ind != 0 || (ind == 0 && list.displayString != '(')">
                                    <div class="close-btn close-metric-icon" title="Remove" (click)="
               removeCustomGroup(
                 list.variableCode,
                 list.operatorValue,
                 ind,
                 list.rowOrder
               )
             "></div>
                                </div>
                            </div>
                        </div>
                        <div class="custom-peer-table-container" *ngIf="isCustomMeanMetric">
                            <div class="custom-peer-tableElement"
                                *ngFor="let list of customCalculationSelectionsObj; let ind = index">
                                <div class="custom-peer-tableElement-span" [ngClass]="{
                                  firstOpeningTag: list.displayString == '(' && ind == 0,
                                  'active-customgroup-item': ind == customCalculationItemIndex
                                }" title="{{ list.displayString }}"
                                    (click)="selectedVariableItem(ind,list.operatorValue)">
                                    {{ list.displayString }}
                                </div>
                                <div class="closeTag" [ngClass]="{
                                  'active-customgroup-item': ind == customCalculationItemIndex
                                }" *ngIf="ind != 0 || (ind == 0 && list.displayString != '(')">
                                    <div class="close-btn close-metric-icon" title="Remove" (click)="
                                    removeCustomCalculation(
                                      list.variableCode,
                                      list.operatorValue,
                                      ind,
                                      list.rowOrder
                                    )
                                  "></div>
                                </div>
                            </div>
                        </div>
                        <div style="height:2.1em;margin-top: auto;">
                            <div class="custom-buttons">
                                <div class="custom-btn" [class.disabled]="!isEditClicked" (click)="cancelEdit()">
                                    <div class="create-icon"></div>
                                    <div class=" create-btn">Cancel</div>
                                </div>
                                <div class="custom-btn" (click)="!isCustomMeanMetric?clearCustomGroupSelection():clearCustomCalculationSelection()">
                                    <div class="delete-icon"></div>
                                    <div class=" clear-btn">Clear</div>
                                </div>
                                <div class="custom-btn"
                                    (click)="!isCustomMeanMetric?saveCustomGroupSelection():saveCustomCalculationSelection()">
                                    <div class="save-icon"></div>
                                    <div class=" save-btn">Save</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="RowContent" [ngClass]="{ hidden: isPreviewExpand }">
                <div class="RowMainContent">
                    <div class="rowHeader">
                        <div class="rowText">Custom Metric List</div>
                    </div>
                    <div class="row-body-block">
                        <div class="rowParent rowParentCustom">
                            <div class="rowParentContent">
                                <div class="custom_metric_lists" *ngFor="let item of existing_custom_metric">
                                    <div class="custom_metric_block">
                                        <div class="custom_metric_name"
                                            [style]="item.notFound?'border:1px solid red':''"
                                            [ngClass]="{'selected':item.isSelected}">
                                            <div class="metricname" [title]="item.name">{{item.name}}</div>
                                        </div>
                                        <div class="widget_edit edit_icon" (click)="onUpdate(item)"></div>
                                        <div class="widget_edit duplicate_icon" (click)="onDuplicate(item)"></div>
                                        <div class="widget_delete trash_icon" (click)="onDelete(item)"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <app-shared-popup *ngIf="isSaveCustomGroupSelectionClick" [isDuplicateCustomGroup]="isDuplicateCustomGroup"
                [isSaveCustomGroupSelectionClick]="isSaveCustomGroupSelectionClick" [showLoaderPopUp]="showLoaderPopUp" [selectionName]="customGroupSelectionName"
                (isCustomGroupSavePopUpVisible)="handleCustomGroupSavePopUp($event)"
                (SaveCustomSelectionClick)="CustomGroupSaveSelection($event)"></app-shared-popup>
            <app-shared-popup *ngIf="isSaveCustomCalculationSelectionClick" [selectionName]="customGroupSelectionName"
                [isDuplicateCustomCalculation]="isDuplicateCustomCalculation"
                [isSaveCustomCalculationSelectionClick]="isSaveCustomCalculationSelectionClick"
                [showLoaderPopUp]="showLoaderPopUp"
                (isCustomCalculationSavePopUpVisible)="handleCustomCalculationSavePopUp($event)"
                (SaveCustomCalculationSelectionClick)="CustomCalculationSaveSelection($event)"></app-shared-popup>
            <!-- <div class="FooterContent" [ngClass]="{ hidden: isPreviewExpand }">
<div class="config-btn config-footer-btn reset-btn"
    [ngClass]="{
   hidden: isCreateCustomGroup || isCreateCustomCalculation
 }"
    (click)="resetPage()">
 (click)="resetPage()">
 <div class="btn-icon reset-icon"></div>
 <div class="btn-text">Reset</div>
</div>
<div class="config-btn config-footer-btn"
    *ngIf="isLoadSelection"
    (click)="loadSelection()"
    title="{{ buttonHoverNames.Load_Selection }}">
 <div class="btn-icon load-icon"></div>
 <div class="btn-text">Load Selection</div>
</div> -->

<app-confirmation-dialog *ngIf="isShowDialog" [messageText]="confirmationMessage"
  (confirmed)="onConfirmation($event)"></app-confirmation-dialog>